import { render, staticRenderFns } from "./NotPatientSelectedModal.template.vue?vue&type=template&id=5f0e35c1&scoped=true&"
var script = {}
import style0 from "./NotPatientSelectedModal.template.vue?vue&type=style&index=0&id=5f0e35c1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0e35c1",
  null
  
)

export default component.exports